export interface InvitationCodeDTO {
  code: string;
  status: string;
  source: string;
  note: string;
  created_at: string;
  updated_at: string;
  assigned_user_id?: number;
  created_by?: number;
  updated_by?: number;
  assigned_at?: string;
}

export interface InvitationCodeListResponseDTO {
  total: number;
  page: number;
  page_size: number;
  items: InvitationCodeDTO[];
}

export interface CreateInvitationCodesRequest {
  codes: string[];
  generate_count: number;
  note: string;
}

export interface CreateInvitationCodesResponse {
  count: number;
  items: InvitationCodeDTO[];
}

export interface AssignInvitationCodeRequest {
  user_id: number;
  invite_code: string;
  note: string;
}

export interface AssignInvitationCodeResponse {
  user_id: number;
  invite_code: string;
  previous_code: string;
  replaced: boolean;
  source: string;
  operator_user: string;
  requested_code: string;
}

export type InvitationCodeStatus = 'available' | 'assigned' | 'disabled';
export type InvitationCodeSource = 'manual' | 'batch_random' | 'system_fallback' | 'backfill' | 'replacement';

export const INVITATION_CODE_STATUS_LABELS: Record<InvitationCodeStatus, string> = {
  available: '可用',
  assigned: '已分配',
  disabled: '已禁用',
};

export const ALL_INVITATION_CODE_STATUSES: InvitationCodeStatus[] = ['available', 'assigned', 'disabled'];

export const INVITATION_CODE_SOURCE_LABELS: Record<InvitationCodeSource, string> = {
  manual: '手动创建',
  batch_random: '批量随机',
  system_fallback: '系统补位',
  backfill: '回填',
  replacement: '替换',
};
